import { gsap } from 'gsap'

document.querySelectorAll('[data-content-card]').forEach((contentCard) => {
    contentCard.addEventListener('mouseenter', () => {
        gsap.to(contentCard.querySelector('[data-links]'), {
            height: 'auto',
            duration: 0.2
        })
    })

    contentCard.addEventListener('mouseleave', () => {
        gsap.to(contentCard.querySelector('[data-links]'), {
            height: 0,
            duration: 0.25
        })
    })
})
